import { h } from 'preact'; /** @jsx h */

import BannerImage from '../components/kjellgunnar/BannerImage/BannerImage';
import CTABlock from '../components/kjellgunnar/CTABlock/CTABlock';
import Content from '../components/kjellgunnar/Content/Content';
import Divider from '../components/kjellgunnar/Divider/Divider';
// import FixedCTA from '../components/kjellgunnar/FixedCTA/FixedCTA';
import FooterCTA from '../components/kjellgunnar/FooterCTA/FooterCTA';
import Heading from '../components/kjellgunnar/Heading/Heading';
import Hero from '../components/kjellgunnar/Hero/Hero';
import Image from '../components/kjellgunnar/Image/Image';
import InlineCTA from '../components/kjellgunnar/InlineCTA/InlineCTA';
import Paragraph from '../components/kjellgunnar/Paragraph/Paragraph';
import Quote from '../components/kjellgunnar/Quote/Quote';
import Section from '../components/kjellgunnar/Section/Section';
import SplitCTABox from '../components/kjellgunnar/SplitCTABox/SplitCTABox';
import StickyQRCTA from '../components/kjellgunnar/StickyQRCTA/StickyQRCTA';
import Video from '../components/kjellgunnar/Video/Video';
import VippsBanner from '../components/kjellgunnar/VippsBanner/VippsBanner';

import '../styles/kjellgunnar/fant-mannen-sin-blodig-og-bevisstlos.scss';

const KjellGunnar = () => {
    return (
        <div className="kjellgunnar">
            <div className="gutters">
                <Hero
                    imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/11/kjellgunnar-hero.jpg"
                    alt="Kjell Gunnar ligger i en sykeseng på sykehuset."
                >
                    <div className="sticky-tag-wrapper">
                        <div className="sticky-tag-container">
                            <span className="sticky-tag">Ingen å miste.</span>
                        </div>
                    </div>
                    <div className="emergency-stripes">
                        <img
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/02/akuttstriper-vertikal-gul.svg"
                            alt="Gule akuttstriper"
                            loading="lazy"
                        />
                    </div>
                    <div className="above-fold">
                        <Heading type="h1" className="hero-title">
                            <span className="hero-title-section">Fant mannen sin</span>
                            <span className="hero-title-section">
                                <span>blodig og bevisstløs</span>
                            </span>
                        </Heading>
                    </div>
                    <div className="hero-overlay">
                        <div className="overlay-padding">
                            <Content width="small">
                                <Paragraph type="ingress" color="all-white">
                                    Tine Mailen Bakken (58) fikk en snap av mannen sin at han var
                                    ferdig med å male oppunder verandaen. Når hun kommer hjem fra
                                    jobb skjønner hun derimot at noe er galt. Stigen ligger
                                    overende. Det er blod på trappen. Ytterdøren er ulåst. På sofaen
                                    finner hun Kjell Gunnar (65) blodig og bevisstløs.
                                </Paragraph>
                                <Paragraph
                                    type="byline"
                                    textAndPhoto="Karoline Lervik Sandvold"
                                    video="Kim Aage Leinhardt"
                                    color="all-white"
                                />
                                <Paragraph color="all-white">
                                    Huset til Kjell Gunnar Bakken og kona Tine, skal selges. Det er
                                    ikke lenge til de skal ha visninger, og Kjell Gunnar vil fikse
                                    noen småting på huset.
                                </Paragraph>
                                <Quote animation="fade-up" color="all-white" borderColor="red">
                                    – Det var et område oppunder verandaen som jeg hadde ergret meg
                                    over i lenger tid, så jeg bestemte meg for å ta med meg
                                    malingsspannet og ordne det før jeg skulle på jobb kl. 16.
                                </Quote>
                                <Paragraph color="all-white">
                                    <b>Det er en avgjørelse som skal få fatale følger.</b>
                                </Paragraph>
                                <Paragraph color="all-white">
                                    Det ender med at Kjell Gunnar faller ned fra stigen og slår
                                    hodet i støttemuren, før han havner i bunn av trappen.
                                </Paragraph>
                                <Quote animation="fade-up" color="all-white" borderColor="red">
                                    – Jeg har nok ligget der en stund før jeg våknet. Jeg hadde
                                    mistet både brillene mine og skoene. Mobilen hadde falt i
                                    malingsspannet, forteller han.
                                    {/* <FixedCTA
                                        color="snla-red"
                                        text="<b>Vær<br /> bedre<br /> forberedt</b>"
                                        buttonText="Last ned<br /><b>Hjelp 113</b><br />gratis"
                                        icon="https://norskluftambulanse.no/wp-content/uploads/2024/09/hjelp-113-app-icon.png"
                                        link="#hjelp-113"
                                    /> */}
                                </Quote>
                                <Paragraph color="all-white">
                                    Deler av øret til Kjell Gunnar blir kuttet av. Ankelen hans er
                                    brukket. Likevel reiser han seg og går rundt huset når han
                                    våkner i bunnen av trappen. Han låser seg inn med kodelåsen, og
                                    går opp i andre etasje for å legge seg i sengen sin. Etter en
                                    stund står han opp og går bort til sofaen i loftstuen for å
                                    legge seg der i stedet.
                                </Paragraph>
                            </Content>
                        </div>
                    </div>
                </Hero>

                <BannerImage
                    imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/11/blod-i-trappen.jpg"
                    alt="Blod i trappen ute på verandaen."
                    contentPlacement="bottom"
                >
                    <Content width="small">
                        <Paragraph></Paragraph>
                        <Heading type="h3" weight="600" color="all-black">
                            Hørte gurglelyder
                        </Heading>
                        <Paragraph color="all-black">
                            <b>
                                Når Tine kommer hjem fra jobb er garasjeporten åpen og ytterdøra
                                står ulåst. Tingene til Kjell Gunnar ligger fortsatt på
                                kjøkkenbordet.
                            </b>
                        </Paragraph>
                    </Content>
                </BannerImage>

                <Section color="off-white">
                    {/* <StickyQRCTA
                        link="#stott-oss"
                        src="https://norskluftambulanse.no/wp-content/uploads/2024/11/QR-kode-Gienjulegave-2024-1.png"
                        title="Støtt videreutvikling av det livreddende arbeidet"
                        orientation="left"
                    /> */}
                    <Content width="small">
                        <Quote animation="fade-up" borderColor="primary">
                            – Jeg kunne umiddelbart se at noe var galt. Jeg skjønte at han ikke var
                            på jobb som han skulle ha vært. Jeg ropte navnet hans flere ganger, men
                            fikk ikke noe svar, forteller hun.
                        </Quote>
                        <Paragraph>
                            Tine løper ut og rundt huset for å se om han kan være der, siden hun
                            tidligere hadde fått en snap fra Kjell Gunnar at han malte. Tingene står
                            fortsatt ute, stiger ligger overende og hun ser blod.
                        </Paragraph>
                        <Quote animation="fade-up" borderColor="primary">
                            – Jeg løp inn igjen og ned i kjelleren hvor han har sitt eget bad. Der
                            var han heller ikke. Da jeg løp opp i andre etasje hørte jeg gurglelyder
                            og så han ligge på sofaen, bevisstløs med oppkast og masse blod rundt
                            seg.
                        </Quote>
                        <Paragraph>
                            Når hun går nærmere ser hun at øret hans er en stor blodkake. Hun
                            forsøker forsiktig å få liv i ham, men Kjell Gunnar gir kun fra seg
                            gurglelyder. Da ringer Tine 113.
                        </Paragraph>
                        <Video
                            src="https://player.vimeo.com/video/1027179858?autoplay=0&autopause=0&muted=0&loop=0&title=0&byline=0&portrait=0"
                            padding="56%"
                            height="380"
                            caption="<b>Inn i en egen boble:</b> Tine gikk automatisk inn i beredskapsmodus da hun fant Kjell Gunnar bevisstløs."
                        />
                        <Paragraph></Paragraph>
                        <Heading type="h3" weight="600" color="all-black">
                            Stua full av helsepersonell
                        </Heading>
                        <Paragraph>
                            Etter å ha gitt all nødvendig informasjon til den medisinske operatøren
                            vil de se Kjell Gunnar med egne øyne. Tine får tilsendt en sms med en
                            lenke slik at nødsentralen får tilgang til kameraet hennes.
                        </Paragraph>
                        <Quote animation="fade-up" borderColor="primary">
                            – Umiddelbart etter at hun fra nødsentralen så Kjell Gunnar tilkalte hun
                            luftambulansen. Ambulansen og lokalt brannvesen var også på vei.
                        </Quote>
                        <Paragraph>
                            Tine får beskjed om å forsøke å holde Kjell Gunnar våken, så hun rister
                            og snakker til han. Det er ikke enkelt, men hun gjør så godt hun kan.
                            Heldigvis tar det kun noen minutter før en lokal brannkonstabel og
                            akutthjelper kommer for å hjelpe henne. For Tine føles det ut som en
                            evighet.
                        </Paragraph>
                        <InlineCTA
                            type="split-2-1"
                            imgSrc="https://norskluftambulanse.no/wp-content/uploads/2024/11/akutthjelpere-under-arctic-race.jpg"
                            alt="Fire Akutthjelpere som holder en banner foran to brannbiler på Arctic Race"
                            color="red"
                            buttonText="<b>Støtt akutthjelperordningen</b>"
                            link="/kompetanse/akutthjelpere/"
                            target="_blank"
                        >
                            <Heading type="h4" color="all-black" weight="600">
                                Akutthjelperordningen
                            </Heading>
                            <Paragraph>
                                <b>
                                    Stiftelsen Norsk Luftambulanse har i 14 år kurset
                                    brannkonstabler over hele landet i førstehjelp slik at de blir
                                    akutthjelpere.
                                </b>
                            </Paragraph>
                            <Paragraph>
                                De spiller en avgjørende rolle da de ofte er raskere fremme hos
                                pasienten enn lege og ambulansepersonell.
                            </Paragraph>
                        </InlineCTA>
                        <Paragraph>
                            På et tidspunkt kan Tine telle 14 personer i stua deres. Alle jobber for
                            at Kjell Gunnar skal overleve. De sikrer frie luftveier, gir han
                            smertestillende og legger ham i kunstig koma. Deretter klargjør de ham
                            for å fly til Ullevål sykehus. De har ingen tid å miste.
                        </Paragraph>
                        <Video
                            src="https://player.vimeo.com/video/1027179875?autoplay=0&autopause=0&muted=0&loop=0&title=0&byline=0&portrait=0"
                            padding="56%"
                            height="380"
                            caption="<b>Tatt vare på:</b> Det er fortsatt sterkt for Tine å snakke om da Kjell Gunnar ble tatt hånd om av helsepersonellet i stua deres."
                        />
                        <Quote animation="fade-up" borderColor="primary">
                            – De ba meg om å gå litt unna, men jeg sa at jeg ville være i nærheten
                            uansett hvor vanskelig det var, forteller hun mens tårene triller
                            nedover kinnene hennes.
                        </Quote>
                        <Paragraph>
                            Så kommer ambulansepersonellet inn, etterfulgt av brannvesenet. Hun
                            hører også at luftambulansen hovrer over huset deres.
                        </Paragraph>
                        <Paragraph>
                            Akutthjelperne og helsepersonellet bærer Kjell Gunnar ut i ambulansen
                            for å ta han med til luftambulansehelikopteret i Svelvik. Igjen står
                            Tine, usikker på hva som kommer til å skje med mannen sin. Men hun vet
                            at hun har gjort alt hun kan og at han er i trygge hender.
                        </Paragraph>
                        <Quote animation="fade-up" borderColor="primary">
                            – Vi fikk beskjed om at helikopteret måtte lande nede i Svelvik, så
                            brannvesenet dro ned for å hente luftambulanselegen og redningsmannen,
                            forteller hun.
                        </Quote>
                    </Content>
                    <FooterCTA
                        href="/kampanje/jul/gave/"
                        linkText="<b>Gi en gave</b><br/>Din støtte bidrar til å redde liv"
                        color="red"
                        bgColor="off-white"
                        textColor="all-white"
                        target="_blank"
                    />
                </Section>
                <Section color="secondary" borderRadius="top">
                    <BannerImage
                        imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/11/tine-og-kjell-gunnar-ved-kjokkenbordet.jpg"
                        alt="Tine og Kjell Gunnar sitter ved kjøkkenbordet."
                        spaceY={false}
                        splitOnMobile
                    />
                </Section>
                <Section color="secondary" borderRadius="bottom">
                    <div className="emergency-stripes">
                        <img
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/02/akuttstriper-vertikal-gul.svg"
                            alt="Gule akuttstriper"
                        />
                    </div>
                    <StickyQRCTA
                        link="/kampanje/jul/gave/"
                        src="https://norskluftambulanse.no/wp-content/uploads/2024/11/QR-kode-Gienjulegave-2024-1.png"
                        title="Støtt videreutvikling av det livreddende arbeidet"
                        orientation="right"
                        spaceY
                        target="_blank"
                    />
                    <Content width="small" spaceY spaceX>
                        <Heading type="h3" weight="600" color="all-white">
                            Boret hull i hodet
                        </Heading>
                        <Paragraph color="all-white">
                            Når luftambulansen ankommer sykehuset blir det stadfestet at Kjell
                            Gunnar har kraniebrudd med påfølgende hjerneblødning. De må bore hull i
                            hodet hans, slik at de får lettet på trykket etter hodeskaden. Det blir
                            også gjennomført plastisk kirurgi på øret hans.
                        </Paragraph>
                        <Paragraph color="all-white">
                            Ingen vet hvordan Kjell Gunnar vil reagere når han våkner. Vil han huske
                            sine nærmeste? Vil han være seg selv?
                        </Paragraph>
                        <Image
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/11/tine-holder-handen-til-kjell-gunnar.jpg"
                            alt="Nærbilde av at Tine holder hånden til Kjell Gunnar."
                            caption="<b>En god støtte:</b> Tine har vært en god støttespiller for Kjell Gunnar både under og etter ulykken."
                            captionColor="all-white"
                        />
                        <Paragraph color="all-white">
                            Heldigvis var all bekymringen unødvendig.
                        </Paragraph>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Han var lavmælt en stund. Svarte kun «ja» og «nei», før det plutselig
                            snudde en dag, smiler Tine.
                        </Quote>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Søsteren hans hadde kjøpt seg en ny mobil, og ut av det blå begynte
                            Kjell Gunnar å forklare både det ene og det andre om hva hun måtte
                            gjøre. Søsteren hans og jeg ble så overrasket, ler hun.
                        </Quote>
                        <Paragraph color="all-white">
                            Det tar tre uker fra han blir lagt inn til han drar fra Ullevål sykehus.
                            Derfra går veien til Sunnaas for å trene opp kroppen og hodet.
                        </Paragraph>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Jeg har startet å skrive dagbok, praktiserer mindfullness og jeg har
                            fått flere verktøy jeg bruker i hverdagen. Jeg er utrolig takknemlig for
                            den gode hjelpen jeg fikk der, forteller Kjell Gunnar.
                        </Quote>
                        <Paragraph color="all-white">
                            Han får også en ny hobby på Sunnaas. I dag er hobbyrommet fylt opp av
                            blant annet lastebiler, kranmaskin, helikopter. Alt bygget i lego.
                        </Paragraph>
                        <Image
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/11/kjell-gunnar-bygger-lego-pa-terrassen.jpg"
                            alt="Kjell Gunnar bygger Lego i sittegruppen på terrassen."
                            caption="<b>Ny hobby:</b> Kjell Gunnar koser seg med å bygge biler og maskiner, av Lego."
                            captionColor="all-white"
                        />
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Jeg har blitt bitt av basillen, ler han.
                        </Quote>
                        <Paragraph color="all-white">Han legger til:</Paragraph>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Legoen bidrar til kognitiv trening, samtidig som det er gøy.
                        </Quote>
                        <Paragraph color="all-white">
                            I dag sliter Kjell Gunnar fortsatt med å forstå hva han har vært
                            gjennom. Ulykken som endret livet hans totalt. Han kan ikke lenger jobbe
                            som bussjåfør, og sliter blant annet med alvorlig fatigue.
                        </Paragraph>
                        <Paragraph color="all-white" type="background">
                            <b>
                                – Jeg har fortsatt ikke skjønt hvor heldig jeg er som sitter her i
                                dag. Det er snakk om flaks og tilfeldigheter, sier Kjell Gunnar mens
                                han ser på kona Tine og smiler.
                            </b>
                        </Paragraph>

                        <FooterCTA
                            href="/kampanje/jul/gave/"
                            linkText="<b>Gi en gave</b><br/>Din støtte bidrar til å redde liv"
                            color="red"
                            bgColor="off-white"
                            textColor="all-white"
                        />
                    </Content>
                </Section>

                <Section color="off-white">
                    <Content width="large">
                        <Divider
                            color="secondary"
                            title="Støtt Stiftelsen Norsk Luftambulanse for en tryggere fremtid"
                        />
                        <SplitCTABox color="secondary" />
                        <VippsBanner />
                    </Content>
                </Section>

                <Section color="off-white">
                    <Content width="large">
                        <CTABlock
                            anchor="hjelp-113"
                            divider
                            color="secondary"
                            title="Det koster ingenting å være bedre forberedt"
                            innerTitle="Last ned Hjelp 113-appen"
                            appleGoogleStore
                            orientation="left"
                            imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/09/hjelp-113-cta-bottom.jpg"
                            alt="Utviklingshelikopteret på øvelse"
                            bulletPoints={[
                                'Alle nødnumre på ett sted (110, 112 og 113)',
                                'Andre viktige numre som nærmeste legevakt og mental helse hjelpetelefon',
                                'Koordinatene der du befinner deg',
                                'Oversikt over hjertestartere i nærheten',
                                'Appen er gratis og har nå 2,6 millioner nedlastninger'
                            ]}
                        />
                    </Content>
                </Section>
            </div>
        </div>
    );
};

export default KjellGunnar;
